import { PRODUCT_QTY_MAX_DEFAULT, PRODUCT_QTY_MIN_DEFAULT } from '~/constants';
import { useMoqRulesLookup } from '~/hooks/useMoqRulesLookup';
import type { ProductMOQLimitsProps } from './useProductMOQLimits.types';

/*
 * Custom hook to determine minimum and maximum order quantity limits for a product.
 *
 * Looks up MOQ rules from the wholesale API lookup table based on the product SKU.
 */
export const useProductMOQLimits = ({ productSku }: ProductMOQLimitsProps) => {
  const { rules: moqRules } = useMoqRulesLookup();

  const moqRule = productSku ? moqRules.get(productSku) : undefined;

  return {
    qtyMinLimit: moqRule?.minQty ?? PRODUCT_QTY_MIN_DEFAULT,
    qtyMaxLimit: moqRule?.maxQty ?? PRODUCT_QTY_MAX_DEFAULT,
  };
};
